import React from "react";
import SectionHeader from "../shared/SectionHeader";
import { CERTIFICATIONS } from "../../data/certifications";

function Certifications() {
  return (
    <section
      id="certifications"
      className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
      aria-label="Certifications"
    >
      <SectionHeader label="CERTIFICATIONS" />

      <div className="grid gap-6 sm:grid-cols-2">
        {CERTIFICATIONS.map((cert) => (
          <div
            key={cert.id}
            className="group relative bg-gradient-to-br from-slate-900/50 to-slate-800/30 border border-slate-700/50 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] backdrop-blur-sm"
          >
            {/* HUD Corners */}
            <div className="absolute top-3 left-3 w-4 h-4 border-l-2 border-t-2 border-cyan-400/60"></div>
            <div className="absolute top-3 right-3 w-4 h-4 border-r-2 border-t-2 border-cyan-400/60"></div>
            <div className="absolute bottom-3 left-3 w-4 h-4 border-l-2 border-b-2 border-cyan-400/60"></div>
            <div className="absolute bottom-3 right-3 w-4 h-4 border-r-2 border-b-2 border-cyan-400/60"></div>

            <div className="flex items-center gap-4">
              <div className="flex-shrink-0">
                <img
                  src={cert.image}
                  alt={cert.title}
                  loading="lazy"
                  decoding="async"
                  className="max-w-full max-h-40 rounded-lg border border-cyan-400/30 shadow object-contain bg-slate-900"
                  style={{ width: "auto", height: "auto" }}
                />
             </div>
              <div>
                <h3 className="text-cyan-400 font-bold text-base font-mono mb-1">{cert.title}</h3>
                <div className="text-[8px] text-gray-400 font-mono mb-1">{cert.issuer}</div>
                <div className="text-xs text-cyan-300 font-mono mb-2">{cert.date}</div>
                {cert.link && cert.link !== "#" && (
                  <a
                    href={cert.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-3 py-1 text-xs font-mono rounded bg-cyan-400/10 border border-cyan-400/30 text-cyan-300 hover:bg-cyan-400/20 hover:text-cyan-200 transition"
                  >
                    View Certificate
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default React.memo(Certifications);